import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import TopBar from 'components/TopBar.vue';
import auth from 'src/api/auth';
import { CLEAR_ERRORS, SET_ERRORS } from 'src/store/types';
import { BfTextInput, BfButton } from 'components/Butterfly';
import { Form, Field } from 'components/forms';
import 'components/forms/rules/email';
export default Vue.extend({
    components: { TopBar, BfTextInput, Form, Field, BfButton },
    data() {
        return {
            email: '',
            success: false,
            loading: false,
            initialFormValues: {
                email: '',
            }
        };
    },
    computed: {
        ...mapGetters(['hasRequestErrors', 'serverErrors'])
    },
    methods: {
        ...mapActions({ CLEAR_ERRORS, SET_ERRORS }),
        async doReconfirm() {
            try {
                this.loading = true;
                this.CLEAR_ERRORS();
                await auth.reconfirmEmail(this.email);
                this.success = true;
            }
            catch (errors) {
                this.SET_ERRORS(errors);
                this.success = false;
            }
            finally {
                this.loading = false;
            }
        }
    }
});
